'use client';

import type { CategoryListItemDto } from '@/queries/categories/categories.schema';
import { useTranslations } from 'next-intl';
import CategoryCard from '@/components/entities/categories/CategoryCard';
import { SliderWrapper } from '@/components/shared/SliderWrapper';

interface MoreCategoriesProps {
  moreCategories: CategoryListItemDto[];
}

const LobbyOtherCategories = ({ moreCategories }: MoreCategoriesProps) => {
  const t = useTranslations('lobby');

  if (moreCategories.length === 0) {
    return null;
  }

  return (
    <section className="mb-5.5">
      <div className="group flex items-center mb-2.5 lg:mb-2.75 gap-2">
        <p className="relative font-medium text-lg leading-5.5 text-white">
          <span>{t('more-categories')}</span>
          <span
            aria-hidden
            className="max-lg:hidden absolute inset-0 bg-main-front-gradient text-gradient opacity-0 transition-opacity duration-200 group-hover:opacity-100 group-active:opacity-100"
          >
            {t('more-categories')}
          </span>
        </p>
      </div>

      <div className="-mx-4 relative overflow-x-clip lg:-mx-10 3xl:mr-0">
        <SliderWrapper>
          <div className="flex w-max gap-2 pl-4 pr-4 lg:pl-10 lg:pr-10 3xl:pr-0">
            {moreCategories.map(category => (
              <div key={category.id} className="w-44.5 h-auto relative shrink-0">
                <div className="absolute inset-0 rounded-[0.75rem] shadow-lg pointer-events-none z-0"></div>
                <CategoryCard category={category} variant="lobby" />
              </div>
            ))}
          </div>
        </SliderWrapper>
        <div
          className="pointer-events-none absolute top-0 right-0 w-23 h-21 z-10 bg-[linear-gradient(270deg,rgba(35,19,51,0.8)_0%,rgba(35,19,51,0.4)_50%,rgba(35,19,51,0)_100%)]"
        />
        <div
          className="pointer-events-none hidden md:block absolute top-0 left-0 w-23 h-21 z-10 bg-[linear-gradient(90deg,rgba(35,19,51,0.8)_0%,rgba(35,19,51,0.4)_50%,rgba(35,19,51,0)_100%)]"
        />
      </div>
    </section>
  );
};

export default LobbyOtherCategories;
